import { render, staticRenderFns } from "./BtnLink.vue?vue&type=template&id=af5d5cc6&scoped=true&"
import script from "./BtnLink.vue?vue&type=script&lang=js&"
export * from "./BtnLink.vue?vue&type=script&lang=js&"
import style0 from "./BtnLink.vue?vue&type=style&index=0&id=af5d5cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5d5cc6",
  null
  
)

export default component.exports